import { PostCartInfoType } from "../../interfaces/postCartInfo/PostCartInfo.type";
import { generateStyleClasses, getGeneralImage, styleHelper } from "../../helpers/commonFunctions";
import styles from './PostCartInfo.module.css';
import FinalizeButton from "../finalizeButton/FinalizeButton";
import { FinalizeButtonDataType } from "../../interfaces/finalizeButton/FinalizeButton.type";
import ContinueButton from "../continueButton/ContinueButton";
import { ContinueButtonDataType } from "../../interfaces/continueButton/ContinueButton.type";
import SkipContinueButton from "../skipContinueButton/SkipContinueButton";
import { SkipContinueButtonDataType } from "../../interfaces/skipContinueButton/skipContinueButton.type";
import { TextLineItem } from "../../interfaces/textLine/TextLine.type";
export default function PostCartInfo({ data }: { data: PostCartInfoType }) {
    const backgroundColor = data.backgroundColor;
    const borderColor = data.borderColor;
    const title = data.title;
    const postCard = data.postCard;
    const separatorColor = data.separator.color;
    const buttonType = data.buttonType;
    const buttonData = data.button;
    const cartItemsText = data.cartItemsText;
    const subTotalText = data.subTotalText;
    const subTotalValText = data.subTotalValText;
    const footer = data.footer;
    const linkHandler = (link: string) => {
        window.location.href = link;
    };
    const buttonComp = () => {
        switch (buttonType) {
            case "finalizeButton":
                return <FinalizeButton items={buttonData as FinalizeButtonDataType} />
            case "continueButton":
                return <ContinueButton items={buttonData as ContinueButtonDataType} />
            case "skipContinueButton":
                return <SkipContinueButton items={buttonData as SkipContinueButtonDataType} />
            default:
                return <></>
        }
    }

    return (<div className={`vas-d-flex vas-flex-column vas-gap-2 vas-border-radius ${styles.bordered}`} style={styleHelper({
        backgroundColor: backgroundColor,
        borderColor: borderColor
    })}>
        <div
            className={`vas-pt-4 vas-d-flex vas-flex-column vas-gap-3 vas-w-100`}>
            <div className={`vas-px-3 as-d-flex vas-text-14 ${generateStyleClasses(title.style)}`} style={styleHelper({
                color: title.textColor
            })}>{title.text}
            </div>
            <div className={`vas-mx-3 vas-d-flex vas-flex-column vas-p-3 vas-gap-2 vas-card vas-border vas-border-radius`}
                style={styleHelper({
                    borderColor: postCard.borderColor,
                    backgroundColor: postCard.backgroundColor
                })}>
                <div className={`vas-d-flex vas-align-items-start vas-w-100 vas-gap-3 vas-border-radius`}>
                    <img
                        className="vas vas-mt-2 vas-border-radius"
                        src={getGeneralImage(postCard.img)}
                        alt="title_icon"
                        height={80}
                        width={120}
                    />
                    <div className={`vas-d-flex vas-flex-column vas-flex-fill vas-gap-2 vas-align-items-start`}>
                        <div className={`vas-d-flex vas-text-break ${generateStyleClasses(postCard.title.style)}`}>
                            {postCard.title.text}
                        </div>
                        <div className={`vas-d-flex ${styles.placeholder_thin} vas-border vas-w-75 vas-border-radius`}
                            style={styleHelper({
                                borderColor: postCard.entity.primaryColor,
                                backgroundColor: postCard.entity.primaryColor
                            })}></div>
                        <div className={`vas-d-flex ${styles.placeholder_thin} vas-border vas-w-50 vas-border-radius`}
                            style={styleHelper({
                                borderColor: postCard.entity.primaryColor,
                                backgroundColor: postCard.entity.primaryColor
                            })}></div>
                    </div>
                </div>
                <div
                    className={`vas-d-flex ${styles.placeholder_thin} ${styles.placeholder_small} vas-border vas-border-radius`}
                    style={styleHelper({
                        borderColor: postCard.entity.primaryColor,
                        backgroundColor: postCard.entity.primaryColor
                    })}></div>
                <div className={`vas-d-flex vas-flex-row vas-justify-content-end`}>
                    <div
                        className={`vas-d-flex ${styles.placeholder_thick} ${styles.placeholder_large} vas-border vas-border-radius`}
                        style={styleHelper({
                            borderColor: postCard.entity.primaryColor,
                            backgroundColor: postCard.entity.primaryColor
                        })}></div>
                </div>
                <div className={`vas-d-flex vas-flex-row vas-gap-1`}>
                    <div
                        className={`vas-d-flex ${styles.placeholder_thickest} vas-w-50 vas-border vas-border-radius`}
                        style={styleHelper({
                            borderColor: postCard.entity.primaryColor,
                            backgroundColor: postCard.entity.primaryColor
                        })}></div>
                    <div
                        className={`vas-d-flex ${styles.placeholder_thickest} vas-w-50 vas-border vas-border-radius`}
                        style={styleHelper({
                            borderColor: postCard.entity.primaryColor,
                            backgroundColor: postCard.entity.secondaryColor
                        })}></div>
                    <div
                        className={`vas-d-flex ${styles.placeholder_thickest} ${styles.placeholder_small} vas-border vas-border-radius`}
                        style={styleHelper({
                            borderColor: postCard.entity.primaryColor,
                            backgroundColor: postCard.entity.primaryColor
                        })}></div>
                </div>
            </div>
            {
                <div className={`vas-d-flex vas-flex-column vas-gap-3`}>
                    <span className={`${styles.separator} vas-0`}
                        style={styleHelper({ borderColor: separatorColor })} />
                    <div className={`vas-d-flex vas-w-100`}>
                        {buttonComp()}
                    </div>
                    <span className={`${styles.separator} vas-0`}
                        style={styleHelper({ borderColor: separatorColor })} />
                </div>
            }
            <div className={`vas-px-3 vas-d-flex vas-text-14 ${generateStyleClasses(cartItemsText.style)}`} style={styleHelper({
                color: cartItemsText.textColor
            })}>{cartItemsText.text}
            </div>
            <div className={`vas-px-3 vas-d-flex vas-justify-content-between`}>
                <div className={`vas-d-flex vas-text-20 ${generateStyleClasses(subTotalText.style)}`}
                    style={styleHelper({
                        color: subTotalText.textColor
                    })}>{subTotalText.text}
                </div>
                <div className={`vas-d-flex vas-text-20 ${generateStyleClasses(subTotalValText.style)}`}
                    style={styleHelper({
                        color: subTotalValText.textColor
                    })}>{subTotalValText.text}
                </div>
            </div>
            <div className={`vas-d-flex vas-align-items-center vas-justify-content-center vas-border-radius`} style={styleHelper({
                backgroundColor: footer.backgroundColor,
                borderTopLeftRadius: 0,
                borderTopRightRadius: 0
            })}>
                <div className={`vas-d-flex vas-p-3 ${styles.py_25}`}>
                    {footer.textPart && footer.textPart.map((item: TextLineItem, idx: number) => {
                        return <div key={idx} onClick={() => {
                            item?.link && linkHandler(item.link)
                        }} className={`${item?.link ? 'pointerCursor' : ''} vas-d-inline vas-me-1 ${generateStyleClasses(item.style)}`}>{item.text}</div>
                    })}
                </div>
            </div>
        </div>
    </div>)
}